import React from 'react';

import { Container } from './styles';

export default function CardHeader({ children }) {
  return (
    <Container>
      {children}
    </Container>
  );
}